import { HttpClient, HttpResponse } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiResponse } from 'src/app/domain/interfaces/application/api-response.interface'
import { environment } from 'src/environments/environment'

const API_URL = environment.apiURL
const BOREAL_URL = environment.borealURL

@Injectable({ providedIn: 'root' })
export class AuthRepositoryService {
  private httpClient: HttpClient = inject(HttpClient)

  public auth2fa(payload: Object): Observable<HttpResponse<ApiResponse>> {
    return this.httpClient.post(`${BOREAL_URL}/authentication/login/2fa`, payload, { observe: 'response' })
  }

  public verify2faCode(payload: Object): Observable<HttpResponse<ApiResponse>> {
    return this.httpClient.post(`${BOREAL_URL}/authentication/login/verify-2fa-code`, payload, { observe: 'response' })
  }

  public sendWhatsappCode(payload: Object): Observable<HttpResponse<any>> {
    return this.httpClient.post(`${BOREAL_URL}/authentication/login/send-whatsapp-code`, payload, { observe: 'response' })
  }

  public sendWhatsappCodeByEmail(): Observable<HttpResponse<any>> {
    return this.httpClient.post(`${BOREAL_URL}/authentication/login/send-whatsapp-code-by-email`, {}, { observe: 'response' })
  }

  public refreshToken(refreshToken: string): Observable<HttpResponse<any>> {
    return this.httpClient.post(`${BOREAL_URL}/authentication/refresh-token`, { refreshToken: refreshToken }, { observe: 'response' })
  }

  public sendCodeEmailResetPassword(payload: Object): Observable<HttpResponse<any>> {
    return this.httpClient.post(`${BOREAL_URL}/auth-user/send-password-reset-code`, payload, { observe: 'response' })
  }

  public verifyPasswordResetCodeEmail(payload: Object): Observable<HttpResponse<any>> {
    return this.httpClient.post(`${BOREAL_URL}/auth-user/verify-password-reset-code`, payload, { observe: 'response' })
  }

  public resetPassword(payload: Object): Observable<HttpResponse<any>> {
    return this.httpClient.patch(`${BOREAL_URL}/auth-user/reset-password`, payload, { observe: 'response' })
  }

  public resetPasswordFirstAccess(payload: Object): Observable<HttpResponse<any>> {
    return this.httpClient.patch(`${BOREAL_URL}/auth-user/reset-first-access-password`, payload, { observe: 'response' })
  }
}
